<fa-icon [icon]="fa[icon]" [fixedWidth]="fixedWidth" [ngClass]=" 'cat-' + icon "></fa-icon>